import React from "react";
import { Link } from "react-router-dom";
import isEmpty from "lodash.isempty";

export default ({ users, onClickDelete }) => {
  const TableOrNotFound = () => {
    if (users.loading) {
      return "is Loading";
    }
    if (isEmpty(users.data)) {
      return <p className="is-size-2 has-text-centered has-text-grey">Found Nothing</p>;
    }
    return (
      <table className="table is-fullwidth is-striped is-hoverable">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Email</th>
            <th>Superuser</th>
            <th>Revoked</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {users.data.map(user => (
            <tr key={user.id}>
              <td>
                <a>{user.id}</a>
              </td>
              <td>{user.name}</td>
              <td>{user.email}</td>
              <td>{user.superuser === 1 ? "Yes" : user.superuser === -1 ? "Pending" : "No"}</td>
              <td>{user.revoked ? "Yes" : "No"}</td>

              <td className="is-icon">
                <p className="buttons">
                  <Link to={`/users/${user.id}/edit`} className="button  is-link is-small">
                    <span className="icon">
                      <i className="fas fa-edit" />
                    </span>
                    <span>Edit</span>
                  </Link>
                  <a
                    onClick={onClickDelete(user.id)}
                    to={`/users/${user.id}/delete`}
                    className="button is-danger is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-trash" />
                    </span>
                    <span>Delete</span>
                  </a>
                </p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };
  return (
    <section className="section">
      <TableOrNotFound />
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/pages/User/Index/Table.js